// ═══════════════════════════════════════════════════════════════════════════════
// Usage region UI strings — merged into uiMessages per locale
// ═══════════════════════════════════════════════════════════════════════════════

import type { UiMessageTable } from './uiMessages.js';

const GROUP_MESSAGES_ZH_HANT: UiMessageTable = {
  'usageRegion.group.asia': '亞洲',
  'usageRegion.group.europe': '歐洲',
  'usageRegion.group.americas': '美洲',
  'usageRegion.group.oceania': '大洋洲',
  'usageRegion.group.africa': '非洲',
};

const REGION_MESSAGES_ZH_HANT: UiMessageTable = {
  'usageRegion.hk': '香港',
  'usageRegion.sg': '新加坡',
  'usageRegion.cn': '中國內地',
  'usageRegion.mo': '澳門',
  'usageRegion.in': '印度',
  'usageRegion.id': '印尼',
  'usageRegion.jp': '日本',
  'usageRegion.my': '馬來西亞',
  'usageRegion.ph': '菲律賓',
  'usageRegion.sa': '沙地阿拉伯',
  'usageRegion.kr': '韓國',
  'usageRegion.tw': '台灣',
  'usageRegion.th': '泰國',
  'usageRegion.ae': '阿聯酋',
  'usageRegion.vn': '越南',
  'usageRegion.asia_other': '亞洲其他地區',
  'usageRegion.dk': '丹麥',
  'usageRegion.fi': '芬蘭',
  'usageRegion.fr': '法國',
  'usageRegion.de': '德國',
  'usageRegion.ie': '愛爾蘭',
  'usageRegion.it': '意大利',
  'usageRegion.nl': '荷蘭',
  'usageRegion.no': '挪威',
  'usageRegion.pt': '葡萄牙',
  'usageRegion.es': '西班牙',
  'usageRegion.se': '瑞典',
  'usageRegion.ch': '瑞士',
  'usageRegion.gb': '英國',
  'usageRegion.europe_other': '歐洲其他地區',
  'usageRegion.ar': '阿根廷',
  'usageRegion.br': '巴西',
  'usageRegion.ca': '加拿大',
  'usageRegion.cl': '智利',
  'usageRegion.co': '哥倫比亞',
  'usageRegion.mx': '墨西哥',
  'usageRegion.us': '美國',
  'usageRegion.americas_other': '美洲其他地區',
  'usageRegion.au': '澳大利亞',
  'usageRegion.nz': '紐西蘭',
  'usageRegion.oceania_other': '大洋洲其他地區',
  'usageRegion.eg': '埃及',
  'usageRegion.za': '南非',
  'usageRegion.africa_other': '非洲其他地區',
};

const GROUP_MESSAGES_ZH_HANS: UiMessageTable = {
  'usageRegion.group.asia': '亚洲',
  'usageRegion.group.europe': '欧洲',
  'usageRegion.group.americas': '美洲',
  'usageRegion.group.oceania': '大洋洲',
  'usageRegion.group.africa': '非洲',
};

const REGION_MESSAGES_ZH_HANS: UiMessageTable = {
  'usageRegion.hk': '香港',
  'usageRegion.sg': '新加坡',
  'usageRegion.cn': '中国内地',
  'usageRegion.mo': '澳门',
  'usageRegion.in': '印度',
  'usageRegion.id': '印尼',
  'usageRegion.jp': '日本',
  'usageRegion.my': '马来西亚',
  'usageRegion.ph': '菲律宾',
  'usageRegion.sa': '沙特阿拉伯',
  'usageRegion.kr': '韩国',
  'usageRegion.tw': '台湾',
  'usageRegion.th': '泰国',
  'usageRegion.ae': '阿联酋',
  'usageRegion.vn': '越南',
  'usageRegion.asia_other': '亚洲其他地区',
  'usageRegion.dk': '丹麦',
  'usageRegion.fi': '芬兰',
  'usageRegion.fr': '法国',
  'usageRegion.de': '德国',
  'usageRegion.ie': '爱尔兰',
  'usageRegion.it': '意大利',
  'usageRegion.nl': '荷兰',
  'usageRegion.no': '挪威',
  'usageRegion.pt': '葡萄牙',
  'usageRegion.es': '西班牙',
  'usageRegion.se': '瑞典',
  'usageRegion.ch': '瑞士',
  'usageRegion.gb': '英国',
  'usageRegion.europe_other': '欧洲其他地区',
  'usageRegion.ar': '阿根廷',
  'usageRegion.br': '巴西',
  'usageRegion.ca': '加拿大',
  'usageRegion.cl': '智利',
  'usageRegion.co': '哥伦比亚',
  'usageRegion.mx': '墨西哥',
  'usageRegion.us': '美国',
  'usageRegion.americas_other': '美洲其他地区',
  'usageRegion.au': '澳大利亚',
  'usageRegion.nz': '新西兰',
  'usageRegion.oceania_other': '大洋洲其他地区',
  'usageRegion.eg': '埃及',
  'usageRegion.za': '南非',
  'usageRegion.africa_other': '非洲其他地区',
};

const GROUP_MESSAGES_EN: UiMessageTable = {
  'usageRegion.group.asia': 'Asia',
  'usageRegion.group.europe': 'Europe',
  'usageRegion.group.americas': 'Americas',
  'usageRegion.group.oceania': 'Oceania',
  'usageRegion.group.africa': 'Africa',
};

const REGION_MESSAGES_EN: UiMessageTable = {
  'usageRegion.hk': 'Hong Kong',
  'usageRegion.sg': 'Singapore',
  'usageRegion.cn': 'Mainland China',
  'usageRegion.mo': 'Macau',
  'usageRegion.in': 'India',
  'usageRegion.id': 'Indonesia',
  'usageRegion.jp': 'Japan',
  'usageRegion.my': 'Malaysia',
  'usageRegion.ph': 'Philippines',
  'usageRegion.sa': 'Saudi Arabia',
  'usageRegion.kr': 'South Korea',
  'usageRegion.tw': 'Taiwan',
  'usageRegion.th': 'Thailand',
  'usageRegion.ae': 'United Arab Emirates',
  'usageRegion.vn': 'Vietnam',
  'usageRegion.asia_other': 'Other Asia',
  'usageRegion.dk': 'Denmark',
  'usageRegion.fi': 'Finland',
  'usageRegion.fr': 'France',
  'usageRegion.de': 'Germany',
  'usageRegion.ie': 'Ireland',
  'usageRegion.it': 'Italy',
  'usageRegion.nl': 'Netherlands',
  'usageRegion.no': 'Norway',
  'usageRegion.pt': 'Portugal',
  'usageRegion.es': 'Spain',
  'usageRegion.se': 'Sweden',
  'usageRegion.ch': 'Switzerland',
  'usageRegion.gb': 'United Kingdom',
  'usageRegion.europe_other': 'Other Europe',
  'usageRegion.ar': 'Argentina',
  'usageRegion.br': 'Brazil',
  'usageRegion.ca': 'Canada',
  'usageRegion.cl': 'Chile',
  'usageRegion.co': 'Colombia',
  'usageRegion.mx': 'Mexico',
  'usageRegion.us': 'United States',
  'usageRegion.americas_other': 'Other Americas',
  'usageRegion.au': 'Australia',
  'usageRegion.nz': 'New Zealand',
  'usageRegion.oceania_other': 'Other Oceania',
  'usageRegion.eg': 'Egypt',
  'usageRegion.za': 'South Africa',
  'usageRegion.africa_other': 'Other Africa',
};

export const USAGE_REGION_UI_MESSAGES_ZH_HANT: UiMessageTable = {
  ...GROUP_MESSAGES_ZH_HANT,
  ...REGION_MESSAGES_ZH_HANT,
};

export const USAGE_REGION_UI_MESSAGES_ZH_HANS: UiMessageTable = {
  ...GROUP_MESSAGES_ZH_HANS,
  ...REGION_MESSAGES_ZH_HANS,
};

export const USAGE_REGION_UI_MESSAGES_EN: UiMessageTable = {
  ...GROUP_MESSAGES_EN,
  ...REGION_MESSAGES_EN,
};

export const USAGE_REGION_UI_MESSAGES_ID: UiMessageTable = {
  ...GROUP_MESSAGES_EN,
  ...REGION_MESSAGES_EN,
};

export const USAGE_REGION_UI_MESSAGES_FIL: UiMessageTable = {
  ...GROUP_MESSAGES_EN,
  ...REGION_MESSAGES_EN,
};
